import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Printer, ArrowLeft } from "lucide-react";
import { GUIDE_STEPS } from "@/components/HowItWorks";

const RATINGS = [
  ["Again", "Didn't know it"],
  ["Hard", "A real struggle"],
  ["Good", "Knew it"],
  ["Easy", "Knew it instantly"],
];

export default function Guide() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FBF7EF] text-[#141821]" style={{ WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }} data-testid="guide-page">
      <div className="max-w-3xl mx-auto p-4 sm:p-8">
        <div className="flex items-center justify-between mb-5 print:hidden">
          <Button variant="ghost" onClick={() => navigate("/flashcards/dashboard")} data-testid="guide-back">
            <ArrowLeft className="h-4 w-4 mr-2" /> Back
          </Button>
          <Button onClick={() => window.print()} data-testid="print-guide-button"
            className="bg-[#FFC200] text-[#141821] hover:bg-[#141821] hover:text-[#FFC200] rounded-full font-semibold">
            <Printer className="h-4 w-4 mr-2" /> Print / Save as PDF
          </Button>
        </div>

        <div className="bg-white rounded-2xl border border-[#141821]/10 p-8 sm:p-10 shadow-sm print:shadow-none print:border-0">
          <img src="/science-sorted-logo.png" alt="Science Sorted" className="h-12 w-auto" />
          <h1 className="mt-6 font-display text-3xl sm:text-4xl font-bold">Your Flashcards — How It Works</h1>
          <p className="mt-2 text-[#141821]/60">Smart revision that shows you the right card at the right time.</p>

          <ol className="mt-8 grid sm:grid-cols-2 gap-5">
            {GUIDE_STEPS.map((s) => (
              <li key={s.n} className="flex gap-3">
                <span className="shrink-0 h-8 w-8 rounded-full bg-[#FFC200] font-display font-bold flex items-center justify-center">{s.n}</span>
                <div>
                  <div className="font-display font-semibold text-lg leading-tight">{s.title}</div>
                  <p className="text-sm text-[#141821]/70 mt-1">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
            {RATINGS.map(([k, v]) => (
              <div key={k} className="rounded-lg border border-[#141821]/10 p-3">
                <div className="font-display font-bold">{k}</div>
                <div className="text-xs text-[#141821]/60 mt-0.5">{v}</div>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-xl bg-[#141821] text-white p-5">
            <div className="font-display font-semibold text-[#FFC200]">The golden rule</div>
            <p className="text-sm mt-1">Answer honestly, come back every day, and let the app decide what you see. A few minutes daily beats a big cram — that's how revision actually sticks.</p>
          </div>

          <p className="mt-8 text-xs text-[#141821]/50 text-center">Science Sorted • Teacher &amp; Examiner-led Tuition</p>
        </div>
      </div>
    </div>
  );
}
